import { gql } from 'src/__generated__';

export const GET_DOCUMENT_DOWNLOAD_LINK = gql(`
  query GetDocumentDownloadLink($resumeId: ID!) {
    viewer {
      documentDownloadLink(resourceId: $resumeId, resourceType: Resume) {
        link
      }
    }
  }
`);
